import { SettingsEndpoint } from "@constants/ApiEndpoints";
import { AxiosInstance } from "axios";
import { OriginOfBookingModel } from "models/Settings/Reservation/originOfBooking/OriginOfBookingModel";
import { FetchingRequestParamsModels } from "models/Shared/FetchingRequestParamsModels";

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<OriginOfBookingModel> => {
    return await axios.delete(
      `${SettingsEndpoint.SETTINGS_RESERVATION_ORIGIN_OF_BOOKING}/${id}`
    );
  };

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: FetchingRequestParamsModels
  ): Promise<OriginOfBookingModel[]> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_RESERVATION_ORIGIN_OF_BOOKING, {
        params,
      })
      .then(({ data }) => data.items);
  };

export const create =
  (axios: AxiosInstance) =>
  async (data: OriginOfBookingModel): Promise<OriginOfBookingModel> => {
    return await axios
      .post(SettingsEndpoint.SETTINGS_RESERVATION_ORIGIN_OF_BOOKING, data)
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: OriginOfBookingModel): Promise<OriginOfBookingModel> => {
    return await axios
      .put(
        `${SettingsEndpoint.SETTINGS_RESERVATION_ORIGIN_OF_BOOKING}/${data.id}`,
        data
      )
      .then(({ data }) => data);
  };

export const toggleStatus =
  (axios: AxiosInstance) =>
  async (id: number): Promise<OriginOfBookingModel> => {
    return await axios
      .patch(`${SettingsEndpoint.SETTINGS_RESERVATION_ORIGIN_OF_BOOKING}/${id}`)
      .then(({ data }) => data);
  };
